import {cyan600, white} from 'material-ui/styles/colors';
import {typography} from 'material-ui/styles';

const styles = {
    subheader: {
        fontSize: 20,
        fontWeight: typography.fontWeightLight,
        backgroundColor: cyan600,
        color: white
    },
    mainDataRow: {
        margin: 0,
        padding: 10
    }
  };

  export default styles;



// WEBPACK FOOTER //
// ./src/components/detailsPage/styles/PDOFDataStyles.js